import RecordBase from './Base';
import { useTranslation } from 'react-i18next';
import dig from 'object-dig';

export default class MedicalAppointmentsRecord extends RecordBase {
  static defaultAttributes = {
    priority: '',
    notes: '',
    status: '',
    record_filename: '',
    record_mp4: '',
    schedule_appointment_at: '',
    appointment_duration: null,
    appointment_at: '',
    uuid: '',
    category: null,
    doctor: null,
    user: null,
    specialty: null,
    attendant: null,
    activities: [],
    no_show_by: null,
    cancel_reason: null,
  };

  static _attributeNames = null;

  static get attributeNames() {
    const { t } = useTranslation();
    if (!this._attributeNames) {
      this._attributeNames = {
        id: t('medicalAppointments.attributes.id'),
        user_phone: t('medicalAppointments.attributes.user_phone'),
        priority: t('medicalAppointments.attributes.priority'),
        notes: t('medicalAppointments.attributes.notes'),
        reason: t('medicalAppointments.attributes.reason'),
        status: t('medicalAppointments.attributes.status'),
        record_filename: t('medicalAppointments.attributes.record_filename'),
        record_mp4: t('medicalAppointments.attributes.record_mp4'),
        uuid: t('medicalAppointments.attributes.uuid'),
        schedule_appointment_at: t(
          'medicalAppointments.attributes.schedule_appointment_at'
        ),
        appointment_at: t('medicalAppointments.attributes.appointment_at'),
        created_at: t('medicalAppointments.attributes.created_at'),
        updated_at: t('medicalAppointments.attributes.updated_at'),
        category: t('medicalAppointments.attributes.category'),
        specialty: t('medicalAppointments.attributes.specialty'),
        doctor: t('medicalAppointments.attributes.doctor'),
        user: t('medicalAppointments.attributes.user'),
        attendant: t('medicalAppointments.attributes.attendant'),
        activities: t('medicalAppointments.attributes.activities'),
        no_show_by: t('medicalAppointments.attributes.no_show_by'),
        cancel_reason: t('medicalAppointments.attributes.cancel_reason'),
        integration_status_sus: t(
          'medicalAppointments.attributes.integration_status_sus'
        ),
      };
    }

    return this._attributeNames;
  }

  toParams() {
    const {
      user_phone,
      priority,
      notes,
      status,
      record_filename,
      record_mp4,
      uuid,
      schedule_appointment_at,
      activities,
      no_show_by,
      cancel_reason,
    } = this.toObject();

    return {
      data: {
        attributes: {
          user_phone,
          priority,
          notes,
          status,
          record_filename,
          record_mp4,
          uuid,
          schedule_appointment_at,
          appointment_category_id: dig(this.get('category'), 'id') || null,
          specialty_id: dig(this.get('specialty'), 'id') || null,
          doctor_id: dig(this.get('doctor'), 'id') || null,
          user_id: dig(this.get('user'), 'id') || null,
          attendant_id: dig(this.get('attendant'), 'id') || null,
          activities,
          no_show_by,
          cancel_reason,
        },
      },
    };
  }
}
